module.exports = __webpack_public_path__ + "img/商品产地.95e3ce20.png";